import { render, staticRenderFns } from "./DialogFeature.vue?vue&type=template&id=6ec7650c&scoped=true&"
import script from "./DialogFeature.vue?vue&type=script&lang=ts&"
export * from "./DialogFeature.vue?vue&type=script&lang=ts&"
import style0 from "./DialogFeature.vue?vue&type=style&index=0&id=6ec7650c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec7650c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDialog,VIcon})
